import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

/** The panel's front door: start an order, pick up the one going, or open a recent one. */
export const Route = createFileRoute("/panel/nancy/")({
  component: lazyRouteComponent(() => import("@/routes/panel/-components/panel-home"), "PanelHome"),
});
